import styled from 'styled-components';

interface CategoryFlagProps {
    index: number;
  flagTitle: string;
  isActive: boolean;
  handleActivateCategory: Function;
}

const CategoryFlag = (props: CategoryFlagProps) => {
  const { index, flagTitle, isActive, handleActivateCategory } = props;
  return (
    <>
      <FlagButton type="button" isActive={isActive} onClick={() => handleActivateCategory(index)}>
        <FlagText isActive={isActive}>{flagTitle}</FlagText>
      </FlagButton>
    </>
  );
};

export default CategoryFlag;

const FlagButton = styled.button<{ isActive: boolean }>`
  height: 3rem;
  padding: 0.3rem 1.6rem;
  border-radius: 10rem;
  border: ${(props) =>
    props.isActive ? `1px solid var(--neutral-white)` : '1px solid  var(--neutral-gray-200)'};
  background: var(${(props) => (props.isActive ? '--primary-1-opacity-50' : '--neutral-white')});
`;

const FlagText = styled.p<{ isActive: boolean }>`
  color: var(--neutral-gray-700);
  color: var(${(props) => (props.isActive ? '--primary-ivy-green-600' : '--neutral-gray-700')});
  text-align: center;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.4rem;
  letter-spacing: 0.018rem;
`;
